import { ResolveBaseApiUrl } from "../utils/Utility";
import APIService from "./APIService";

const baseUrl = ResolveBaseApiUrl() + "Investigator/";
const investigatorAPIService = new APIService(baseUrl);

export async function GetInvestigatorsName() {
  var url = "getinvestigatorsname";
  return await investigatorAPIService.fetchData(url);
}

export async function GetInvestigatorData() {
  var url = "getinvestigatorsdata";
  return await investigatorAPIService.fetchData(url);
}
